import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBadgeResource } from "../types";

export type IBadgeQueryParameters = {
    badge?: RelationalValue<IBadgeResource>;
};

export type IBadgeQueryResult = IBadgeResource;

export const badgeQuery: IApiQueryFunction<IBadgeQueryParameters> = ({ badge }) => {
    if (!badge) {
        return;
    }

    return {
        method: "GET",
        url: `/badges/${mapRelationalValue(badge)}`,
    };
};

export const useBadgeQuery = createApiQueryHook<IBadgeQueryParameters, IBadgeQueryResult>(badgeQuery);
